import IcomoonIcon from "@icons/IcomoonIcon";
import SntActionButton from "@/cleanup/components/Buttons/SntActionButton";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";

interface ConfigButtonProps {
  onConfigColumn: () => void;
}

export const ConfigButton = ({ onConfigColumn }: ConfigButtonProps) => {
  return (
    <SntActionButton
      title={translate(LanguageKey.configure_view_key)}
      onClick={(e) => {
        e.preventDefault();
        onConfigColumn();
      }}
    >
      <IcomoonIcon icon="cog" color="#0071a1" size="16" />
    </SntActionButton>
  );
};
